const fallbackGatewayIp = process.env.REACT_APP_API_HOST ?? "https://xdt-api.x-dream-media.com";

const runtimeGatewayIp = window.__APP_CONFIG__?.API_HOST?.trim();

export const GatewayIp = runtimeGatewayIp || fallbackGatewayIp;

export const endpoints = {
    resources: "/api/resources",
    auth: 
    { 
        login: "/auth/login",
        changePassword: "/api/admin/password"
    },
    jobmonitor: {
        getJobs: "/api/jobmonitor/jobs",
        getSources: "/api/jobmonitor/jobs/sources",
    },
    watchfolder: {
        getWatchfolders: "/api/ingest/watchfolder", //?page=1&size=20
        getEngines: "/api/ingest/dispatch/engines",
        metadataCleanup: (id: string) => `/api/ingest/watchfolder/${id}/metadata/cleanup`,
    },
    ingest: {
        jobs: "/api/ingest/ingest/jobs",
    },
    scheduler: {
        schedules: "/api/scheduler/schedules",
        slots: "/api/scheduler/slots",
        slotPreview: (slotId: string) => `/api/scheduler/slots/${encodeURIComponent(slotId)}/preview`,
        profiles: "/api/scheduler/mediaengine/profiles",
        deviceCatalogue: "/api/scheduler/mediaengine/device-catalogue",
    },
    filequeuer: {
        getResourceFiles: (resourceId: string) => `/api/ingest/filequeuer/resources/${encodeURIComponent(resourceId)}/files`,
        submitJob: "/api/ingest/filequeuer/jobs/submit"
    },
    thirdparty: {
        cambriaProfiles: "/api/thirdparty/cambria/profiles",
        cambriaProfile: (id: number | string) => `/api/thirdparty/cambria/profiles/${id}`,
        cambriaEndpoints: "/api/thirdparty/cambria/endpoints",
        cambriaEndpoint: (id: number | string) => `/api/thirdparty/cambria/endpoints/${id}`,
    }
}
